// src/components/.../Nav.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import "./Nav.css";

function Nav() {
  const isLoggedIn = useSelector((state) => state.user);
  const { t } = useTranslation();

  return (
    <ul className="nav-links">
      <li>
        <NavLink
          to="/about"
          className={({ isActive }) =>
            isActive ? "nav-link active" : "nav-link"
          }
        >
          {t("nav.about")}
        </NavLink>
      </li>

      <li>
        <NavLink
          to="/privacy"
          className={({ isActive }) =>
            isActive ? "nav-link active" : "nav-link"
          }
        >
          {t("nav.privacy")}
        </NavLink>
      </li>

      <li>
        <NavLink
          to="/terms"
          className={({ isActive }) =>
            isActive ? "nav-link active" : "nav-link"
          }
        >
          {t("nav.terms")}
        </NavLink>
      </li>

      {isLoggedIn?.accessToken && (
        <li>
          <NavLink
            to="/profile"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            {t("Profile")}
          </NavLink>
        </li>
      )}
    </ul>
  );
}

export default Nav;
